import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_15 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_28 = { class: "pb-5" }
const _hoisted_29 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }

import comarcas from "@/core/data/comarcas";
import tratamientos from "@/core/data/tratamientos";
import { FamiliaListado } from "@/store/models";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  familia: {
    type: Object as () => FamiliaListado,
    required: true,
  },
},
  setup(__props) {

const props = __props



const familiaData = computed(() => props.familia);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.servicioDetalle.datosFamilia")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_select, {
              disabled: "",
              name: "tratamiento",
              class: "w-100",
              modelValue: _unref(familiaData).tratamiento,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(familiaData).tratamiento) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tratamientos), (tratamiento, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: i,
                    label: tratamiento.text,
                    value: tratamiento.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_input, {
                  disabled: "",
                  type: "text",
                  name: "nombre",
                  placeholder: " ",
                  modelValue: _unref(familiaData).nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(familiaData).nombre) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_input, {
                  disabled: "",
                  type: "text",
                  name: "apellidos",
                  placeholder: " ",
                  modelValue: _unref(familiaData).apellidos,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(familiaData).apellidos) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_input, {
              disabled: "",
              type: "text",
              name: "dni",
              placeholder: " ",
              modelValue: _unref(familiaData).dni,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(familiaData).dni) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_input, {
              disabled: "",
              type: "text",
              name: "email",
              placeholder: " ",
              modelValue: _unref(familiaData).email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(familiaData).email) = $event))
            }, {
              append: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_el_input, {
              disabled: "",
              type: "text",
              name: "telefono",
              placeholder: " ",
              modelValue: _unref(familiaData).telefono,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(familiaData).telefono) = $event))
            }, {
              append: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_el_input, {
              disabled: "",
              type: "text",
              name: "direccion",
              placeholder: " ",
              modelValue: _unref(familiaData).direccion,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(familiaData).direccion) = $event))
            }, {
              append: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_el_input, {
              disabled: "",
              type: "text",
              name: "localidad",
              placeholder: " ",
              modelValue: _unref(familiaData).localidad,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(familiaData).localidad) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("formularios.servicioDetalle.comarca.label")), 1),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_select, {
              disabled: "",
              name: "comarcaId",
              modelValue: _unref(familiaData).comarcaId,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(familiaData).comarcaId) = $event)),
              class: "w-100"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comarcas), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.text,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_el_input, {
              disabled: "",
              type: "text",
              name: "provincia",
              placeholder: " ",
              modelValue: _unref(familiaData).provincia,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(familiaData).provincia) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}
}

})